import { Link } from '@/components/Link';
import { ValidationMessage } from '@/constants';
import { useValidation } from '@/contexts/validationContext';
import * as Styled from './ValidationErrorNotification.styled';

const handleClick = (name: string) => () => {
  const validatedSection = document.querySelector(
    `[data-validation-key="${name}"]`,
  );
  const focusTarget =
    validatedSection?.querySelector<HTMLLabelElement>(
      '[data-invalid="true"] input',
    ) ?? validatedSection?.querySelector<HTMLButtonElement>('button');
  focusTarget?.focus();
};

export const ValidationErrorNotification = () => {
  const { errorMessages } = useValidation();

  return (
    <Styled.Notification>
      <p>{ValidationMessage.ErrorSummary}</p>
      <ul>
        {Object.entries(errorMessages).map(([key, value]) => (
          <li key={key}>
            <Link handler={handleClick(key)} isButton={true}>
              {value}
            </Link>
          </li>
        ))}
      </ul>
    </Styled.Notification>
  );
};
